module.exports = __webpack_public_path__ + "img/c3.46ec0228.png";